import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {

    getLogin () {
        return axios.get('/api/users/login/get')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    
    ChangePassword(oldPassword,newPassword,confirmationPassword){
        return axios.post('/api/users/password/change', {oldPassword: oldPassword, newPassword: newPassword, confirmationPassword:confirmationPassword})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.users.changePassword'))
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    getTraders (page, pageSize,usersFilter) {
        return axios.get('/api/users/list', { params: { page: page, pageSize: pageSize,usersFilter:usersFilter} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllTraders () {
        return axios.get('/api/users/list/all')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    updatePassword(selectedUserId,newPassword){
        return axios.post("/api/users/admin/password/change/"+selectedUserId,{newPassword:newPassword})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.users.changePassword'));
                 return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTradersClients (page, pageSize,tradersId,filter) {
        return axios.get('/api/users/customers', { params: {page: page, pageSize: pageSize,tradersId:tradersId,filter:filter} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addCustomersToTrader (selectedCustomers,traderId) {
        return axios.post('/api/users/addCustomersToTrader', {list : selectedCustomers, traderId:traderId}  )
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success(i18n.t('services.users.addCustomersToTrader'));
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeCustomerFromTrader (customerId,traderId) {
        return axios.post('/api/users/removeCustomerFromTrader', {customerId : customerId, traderId:traderId}  )
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success(i18n.t('services.users.removeCustomerFromTrader'));
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    editSelection (selectedCustomers,traderId) {
        return axios.post('/api/users/editTradersClients', {list : selectedCustomers, traderId:traderId}  )
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success(i18n.t('services.users.editSelection'));
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveUser(user){
        return axios.post("/api/users/save/",user)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.users.saveUser'));
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPrivileges () {
        return axios.get('/api/users/privileges')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTradersPriviliges (tradersId) {
        return axios.get('/api/users/trader/privileges', { params: {tradersId:tradersId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addPriviligesToTrader (selectedPriviliges,traderId) {
        return axios.post('/api/users/addPriviligesToTrader', {list : selectedPriviliges, traderId:traderId}  )
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success(i18n.t('services.users.addPriviligesToTrader'));
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removePrivilegeFromTrader (privilegeId,traderId) {
        return axios.post('/api/users/removePrivilegeFromTrader', {privilegeId : privilegeId, traderId:traderId}  )
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success(i18n.t('services.users.removePrivilegeFromTrader'));
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTradersCount(){
        return axios.get('/api/users/count')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getUserInfo (id) {
        return axios.get('/api/users/info/',{ params: { id: id } })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    isSuperClient () {
        return axios.get('/api/users/is-super-client')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    adminUpdatePassword(selectedUserId,newPassword){
        return axios.post('/api/users/admin/password/change/'+selectedUserId,{newPassword : newPassword} )
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.users.changePassword'))
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    acceptTerms(){
        return axios.post('/api/users/accept/' )
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveTraderToCustomer(user){
        return axios.post("/api/users/saveTraderToCustomer/",user)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.users.saveTraderToCustomer'));
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTrader (customerId) {
        return axios.get('/api/users/trader/',  { params: {customerId : customerId} })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPrivacyPolicy () {
        return axios.get('/api/users/privacyPolicy/')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    setLanguage(code){
        return axios.post("/api/users/set/language/"+code)
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getLastConnection () {
        return axios.get('/api/users/lastConnection/')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getChatUsers (page, pageSize,filter) {
        return axios.get('/api/users/chatUsers/', { params: {page: page, pageSize: pageSize,filter:filter} })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getCurrentUserId () {
        return axios.get('/api/users/id')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getRecentUsers () {
        /*return axios.get('/api/users/recentChatUsers/')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})*/
    },

    setSimulatedCustomer (customerId) {
        return axios.post('/api/users/set/simulatedCustomer', {customerId : customerId}  )
        .then(response => {
            if (response && response.data){
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSimulatedCustomer () {
        return axios.get('/api/users/get/simulatedCustomer')
        .then(response => {
            if (response && response.data){
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    
    addAccountRequest (formData) {
        return axios.post('/api/users/add-account-request', formData , {
         headers: { 'Content-Type': 'multipart/form-data' } }
        )
        .then(response => {
            if (response && response.data){
                return response.data;
            } 
        })
        /*.catch(error => {Vue.prototype.$snotify.error(error);})*/
    },
}